import { render, staticRenderFns } from "./GradeDetailForm.vue?vue&type=template&id=684dfc3b&"
import script from "./GradeDetailForm.vue?vue&type=script&lang=js&"
export * from "./GradeDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports